import React from 'react'

import { StaticImage } from 'gatsby-plugin-image'

import { Link } from 'gatsby'
import { FaDiscord } from '@react-icons/all-files/fa/FaDiscord'
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter'
import { FaMusic } from '@react-icons/all-files/fa/FaMusic'
import { FaCode } from '@react-icons/all-files/fa/FaCode'
import { FaEnvelope } from '@react-icons/all-files/fa/FaEnvelope'

const Footer = () => (
  <div className="container w-full mx-auto">
    <div className="w-full h-0.5 bg-gradient-100"></div>

    <footer className="grid grid-cols-1 md:grid-cols-2 my-6">
      <nav className="text-sm">
        <ul>
          <li className="inline-block px-2">
            <a
              href="https://twitter.com/topdogstudios"
              target="_blank"
              rel="noreferrer noopener"
              title="Follow us on Twitter"
            >
              <FaTwitter className="text-xl text-blue-400 hover:text-blue-500" />
            </a>
          </li>

          <li className="inline-block px-2">
            <a
              href="https://discord.gg/topdogbeachclub"
              target="_blank"
              rel="noreferrer noopener"
              title="Join the discussion on Discord"
            >
              <FaDiscord className="text-xl text-indigo-500 hover:text-indigo-600" />
            </a>
          </li>

          <li className="inline-block px-2">
            <a
              href="mailto:hello@topdogstudios.io"
              target="_blank"
              rel="noreferrer noopener"
              title="Drop us an e-mail"
            >
              <FaEnvelope className="text-xl text-white hover:text-gray-200" />
            </a>
          </li>
        </ul>
      </nav>

      <nav className="text-sm self-end">
        <div className="flex flex-col items-end w-full">
        <div className='flex flex-row gap-4'>
        <a className="text-white no-underline" href="/who-we-are"><p>who we are</p></a>
        <p className="text-gray-500 text-right text-sm">2021 Darkport Technologies Limited</p>
        </div>
        </div>
      </nav>
    </footer>
  </div>
)

export default Footer
